export default __webpack_public_path__ + "static/media/es.895b0586.svg";